import { endOfMonth, startOfMonth, addDays } from 'date-fns';
import { calendarParts, fromCalendarDate, isoDate } from '../calendarSystem';
export function isGregorianLeapYear(year) { return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0); }
export function getEthiopianDate(dateArray) {
  const inputs = Array.isArray(dateArray) ? dateArray : [...arguments];
  try { const p = calendarParts(isoDate(...inputs), 'ethiopic'); return { ethiopianYear: p.year, ethiopianMonth: p.month, ethiopianDay: p.day }; } catch { return null; }
}
export function convertEthiopianToGregorian(dateArray) {
  const inputs = Array.isArray(dateArray) ? dateArray : [...arguments];
  try { const [year, month, day] = fromCalendarDate(...inputs, 'ethiopic').split('-').map(Number); return { gregorianYear: year, gregorianMonths: month, gregorianDate: day }; } catch { return null; }
}

export function toGeezNumber(number) {
    if (number < 0 || number >= 100000) return "number has to be less than 99999";
    if (number === 0) return "ዜሮ";
  
    const geezDigits = ["፩", "፪", "፫", "፬", "፭", "፮", "፯", "፰", "፱"];
    const geezTens = ["፲", "፳", "፴", "፵", "፶", "፷", "፸", "፹", "፺"];
    const geezHundred = "፻";
    const geezTenThousand = "፼";
  
    let result = "";
  
    // Handle 10,000s
    if (number >= 10000) {
      const tenThousands = Math.floor(number / 10000);
      result += (tenThousands === 1 ? "" : (tenThousands <= 9 ? geezTens[tenThousands - 1] : geezDigits[tenThousands - 1])) + geezTenThousand;
      number %= 10000;
    }
  
    // Handle 1,000s (multiples of 100)
    if (number >= 1000) {
      const thousands = Math.floor(number / 1000); 
      result += (thousands === 1 ? "" : geezTens[thousands - 1]) + geezHundred;
      number %= 1000;
    }
  
    // Handle 100s
    if (number >= 100) {
      const hundreds = Math.floor(number / 100);
      result += (hundreds === 1 ? "" : geezDigits[hundreds - 1]) + geezHundred;
      number %= 100;
    }
  
    // Handle 10s
    if (number >= 10) {
      const tens = Math.floor(number / 10);
      result += geezTens[tens - 1];
      number %= 10;
    }
  
    // Handle units
    if (number > 0) {
      result += geezDigits[number - 1];
    }
  
    return result;
  }
  
export const ethiopianMonths = ["መስከረም", "ጥቅምት", "ህዳር", "ታህሳስ", "ጥር", "የካቲት", "መጋቢት", "ሚያዝያ", "ግንቦት", "ሰኔ", "ሐምሌ", "ነሐሴ", "ጳጉሜ"];

export function toEthiopianMonth(ethiopianMonth) {

    return `${ethiopianMonths[ethiopianMonth - 1]} `;
}

export function toEthiopianGeezLong(gregorianYear, gregorianMonth, gregorianDay) {
    const { ethiopianYear, ethiopianMonth, ethiopianDay } = getEthiopianDate(gregorianYear, gregorianMonth, gregorianDay);

    return `${ethiopianDay} ${ethiopianMonths[ethiopianMonth - 1]} ${ethiopianYear}`;
}

export function toEthiopianShortDate(gregorianYear, gregorianMonth, gregorianDay) {
    const { ethiopianYear, ethiopianMonth, ethiopianDay } = getEthiopianDate(gregorianYear, gregorianMonth, gregorianDay);
    return `${ethiopianDay}/${ethiopianMonth}/${ethiopianYear}`;
}

export function toGeezDate(gregorianYear, gregorianMonth, gregorianDay) {
    const ethiopianDays = ["እሁድ", "ሰኞ", "ማክሰኞ", "ረቡዕ", "ሐሙስ", "ዓርብ", "ቅዳሜ"];
    const ethiopianMonths = ["መስከረም", "ጥቅምት", "ህዳር", "ታህሳስ", "ጥር", "የካቲት", "መጋቢት", "ሚይዚያ", "ግንቦት", "ሰኔ", "ሐምሌ", "ነሐሴ", "ጳጉሜ"];
    const { ethiopianYear, ethiopianMonth, ethiopianDay } = getEthiopianDate(gregorianYear, gregorianMonth, gregorianDay);

    const dayOfWeek = new Date(Date.UTC(gregorianYear, gregorianMonth - 1, gregorianDay)).getUTCDay();

    return `${ethiopianDays[dayOfWeek]}, ${ethiopianDay} ${ethiopianMonths[ethiopianMonth - 1]} ${ethiopianYear}`;
}

// utils/ethiopianCalendar.js
export function getEthiopianMonthsInGregorianMonth(monthDate) {
    const start = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1);
    const end = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0);
  
    const seen = new Set();
    const monthsWithYears = [];
  
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      const ethDate = getEthiopianDate(d.getFullYear(), d.getMonth() + 1, d.getDate());
      const key = `${ethDate.ethiopianMonth}-${ethDate.ethiopianYear}`;
      if (!seen.has(key)) {
        monthsWithYears.push([toEthiopianMonth(ethDate.ethiopianMonth), ethDate.ethiopianYear]);
        seen.add(key);
      }
    }
  
    return { monthsWithYears };
  }
  
  export const groupEthiopianMonthsByYear = (monthsWithYears) => {
    const grouped = {};
    monthsWithYears.forEach(([month, year]) => {
      if (!grouped[year]) grouped[year] = [];
      grouped[year].push(month);
    });
    return grouped;
};
  
const EthiopianCalendar = {
    isGregorianLeapYear,
    getEthiopianDate,
    convertEthiopianToGregorian,
    toGeezNumber,
    toEthiopianGeezLong,
    toEthiopianShortDate,
    toGeezDate,
    getEthiopianMonthsInGregorianMonth,
    toEthiopianMonth,
    groupEthiopianMonthsByYear
};

// Export the object
export default EthiopianCalendar;